export class ComponentDialogResult {

    public IsAccepted: boolean = false;
    public IsDataSourceAltered: boolean = false;
    public DataSource: any | null;
}
